"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const initiativeItems = [{
  title: "LIGHT FOR THE LOST",
  description: "Light for the Lost apoya a los misioneros proporcionando literatura y herramientas de medios esenciales para difundir el evangelio alrededor del mundo.",
  buttonText: "MÁS INFORMACIÓN",
  link: "/MinistriesPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ministry_light_for_the_lost.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ministry_light_for_the_lost.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ministry_light_for_the_lost.png-wvc-sizes",
  imageAlt: "Ministry team sharing resources and outreach materials"
}, {
  title: "LIGHT THE WAY",
  description: "Light the Way une a mujeres en torno a la causa de las misiones, dando a favor de las víctimas y los marginados.",
  buttonText: "MÁS INFORMACIÓN",
  link: "/MinistriesPage",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ministry_light_the_way.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ministry_light_the_way.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/ministry_light_the_way.png-wvc-sizes",
  imageAlt: "Two women embracing outdoors in compassionate community"
}];
export default function Ministryinitiatives() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="ministryinitiatives" data-nav="light" className="w-full bg-background py-12 md:py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-6 md:gap-8 lg:grid-cols-2">
          {initiativeItems.map((item, i) => <motion.div key={item.title} data-index={i} initial={{
          opacity: 0,
          y: shouldReduceMotion ? 0 : 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15,
          ease: "easeOut"
        }} className="group relative flex min-h-[440px] flex-col justify-end overflow-hidden rounded-3xl bg-muted shadow-md sm:min-h-[480px] lg:min-h-[520px]">
              {}
              <div className="absolute inset-0 z-0">
                <img src={item.imageSrc} data-wvc-srcset={item.imageSrcset} data-wvc-sizes={item.imageSizes} alt={item.imageAlt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                <div className="absolute inset-0 bg-black/10 transition-opacity duration-300 group-hover:bg-black/5" />
              </div>

              {}
              <div className="relative z-10 p-4 sm:p-6 lg:p-8">
                <div className="max-w-md rounded-2xl bg-card p-6 shadow-lg sm:p-8">
                  <h3 className="font-default text-xl font-bold tracking-wider text-card-foreground uppercase sm:text-2xl">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                    {item.description}
                  </p>
                  <div className="mt-5">
                    <Button asChild className="inline-flex h-9 items-center gap-1.5 rounded-full bg-foreground px-4 text-xs font-semibold tracking-wider text-background uppercase shadow-xs transition-transform duration-200 hover:scale-105 hover:bg-foreground/90 active:scale-95">
                      <Link to={item.link}>
                        <span>{item.buttonText}</span>
                        <ArrowUpRight className="size-3.5 stroke-[2.5]" />
                      </Link>
                    </Button>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}